"use client";

import type { Rating as OfficeRating } from "@homeinstead/schemas";
import type { PortableTextBlock } from "next-sanity";
import type { LeadSource } from "~www/types/forms/care-seeker-shallow-lead-form";
import type { HeroVariant } from "./shared/hero-variants";

import CareSeekerLeadFormV1 from "./v1/CareSeekerLeadFormV1";
import CareSeekerLeadFormV2 from "./v2/CareSeekerLeadFormV2";
import CareSeekerLeadFormV4 from "./v4/CareSeekerLeadFormV4";
import CareSeekerLeadFormV5 from "./v5/CareSeekerLeadFormV5";

export interface CareSeekerLocalLeadFormProps {
  version: "v1" | "v2" | "v4" | "v5";
  currentStep: number;
  handleBack: () => void;
  handleNext: () => void;
  finalStep: number;
  isDebug?: boolean;
  heroHeading: PortableTextBlock[];
  placeholders?: Record<string, string>;
  franchiseId: number;
  location: { name: string; postalCode: string };
  officeRating?: OfficeRating | null;
  phoneNumber: string;
  leadSource: LeadSource;
  variant?: HeroVariant;
  className?: string;
}

export function CareSeekerLocalLeadForm({
  version,
  ...props
}: CareSeekerLocalLeadFormProps) {
  if (version === "v2") {
    return <CareSeekerLeadFormV2 {...props} />;
  }
  if (version === "v4") {
    return (
      <CareSeekerLeadFormV4
        {...props}
        leadSource={props.leadSource as "fo-home-page"}
      />
    );
  }
  if (version === "v5") {
    return (
      <CareSeekerLeadFormV5
        {...props}
        leadSource={props.leadSource as "fo-home-page"}
      />
    );
  }
  return <CareSeekerLeadFormV1 {...props} />;
}
